// export interface Environment {
//   production: boolean;
//   devMode: boolean;
//   suppressErrorPage: boolean;
//   billingCareCentreEmail: string;
//   billingPersonalLinesEmail: string;
//   billingCommercialLinesEmail: string;
//   billingInternalFromEmail: string;
//   policyChangeRequestInternal: string;
//   policyGracePeriodNotificatonInternal: string;
//   policyGracePeriodNotificatonInternalAgencyMailbox: string;
//   claimContantAdjusterInternal: string;
//   claimReportClaimInternal: string;
//   partnerBillingEmail: string;
//   partnerClaimEmail: string;
//   partnerAdjusterEmail: string;
//   partnerLicensedAdvisorEmail: string;
//   gaProperty: string;
//   currentDate: Date;
// }

export interface EnvironmentConfigAdmin extends EnvironmentConfigAdminShared {
  applicationTitle: string;
  featureOverride: { [key: string]: boolean };
  version: string;
  features: {
    chat: string;
    partner: string;
    partnerSso: string;
    saveUserID: string;
    typeZeroSecurityQuestions: string;
    opportunities: string;
    photoUpload: string;
    upsellOpportunities: string;
    postFnolFlow: string;
    mobileAppBanner: string;
    accidentChecklist: string;
    tokenBasedEnrollment: string;
    classicPastDue: string;
    adminPhase32: string;

    // environment values
    production?: false;
    devMode?: boolean;
    suppressErrorPage?: boolean;
    billingCareCentreEmail?: string;
    billingPersonalLinesEmail?: string;
    billingCommercialLinesEmail?: string;
    billingInternalFromEmail?: string;
    policyChangeRequestInternal?: string;
    policyGracePeriodNotificatonInternal?: string;
    claimContantAdjusterInternal?: string;
    claimReportClaimInternal?: string;
    partnerBillingEmail?: string;
    partnerClaimEmail?: string;
    partnerAdjusterEmail?: string;
    gaProperty?: string;
    afiApiKey?: string;
  };
  // only in config.json, used for interpolation
  amfamDotCom?: string;
  apps?: string;
  myDotAmfam?: string;
  gateway?: string;
  contentApiGateway?: string;
  sitecoreLambda?: string;
  partnerLandingPageTier?: string;
  finAccount?: string;
  payNow?: string;
  // API endpoints
  addressLookupApi: string;
  alternateAuthApi: string;
  autoWhatIfApi: string;
  billingApi: string;
  brandApi: string;
  ebsBrandApi: string;
  afeApiKey: string;
  communicationApi: string;
  contentApi: string;
  contextRouterApi: string;
  customerUploadApi: string;
  deleteAccountApi: string;
  digitalAccountApi: string;
  digitalServiceProgramApi: string;
  discountApi: string;
  documentApi: string;
  claimVendorLocations: string;
  eSignatureApi: string;
  financialAccountService: string;
  financialAccountServiceInternal: string;
  gatewayTimeApi: string;
  geoApi: string;
  i3Api: string;
  i3ApigeeApi: string;
  maev2Api: string;
  maev3Api: string;
  partyApi: string;
  paymentApi: string;
  payoroboApi: string;
  pciAuthorizationService: string;
  producerApi: string;
  productApi: string;
  recommenderApi: string;
  sitecoreApi: string;
  sitecoreLambdaApi: string;
  ssoApi: string;
  vehicleApi: string;
  // API endpoint versions
  addressLookupApiVersion?: string;
  alternateAuthApiVersion?: string;
  autoWhatIfApiVersion?: string;
  billingApiVersion?: string;
  brandApiVersion?: string;
  ebsBrandApiVersion?: string;
  communicationApiVersion?: string;
  contentApiVersion?: string;
  customerUploadApiVersion?: string;
  deleteAccountApiVersion?: string;
  digitalAccountApiVersion?: string;
  digitalServiceProgramApiVersion?: string;
  discountApiVersion?: string;
  documentApiVersion?: string;
  claimVendorLocationsVersion?: string;
  eSignatureApiVersion?: string;
  finAccountVersion?: string;
  gatewayTimeApiVersion?: string;
  geoApiVersion?: string;
  maeV2ApiVersion?: string;
  maeV3ApiVersion?: string;
  partyApiVersion?: string;
  paymentApiVersion?: string;
  pciAuthorizationApiVersion?: string;
  producerApiVersion?: string;
  productApiVersion?: string;
  ssoApiVersion?: string;
  vehicleApiVersion?: string;
  // links
  links: {
    amfamDotComUrl: string;
    amfamDotComClaimsFaqUrl: string;
    amfamDRPShopSearchUrl: string;
    fxm: string;
    launch: string;
    nortonSecurity: string;
    propertyServiceSsoUrl: string;
    propertyServiceUrl: string;
    scheduleACallbackUrl: string;
    payNowURL: string;
    myAccountURL: string;
    companyInfoPage: string;
    claimsPortalUrl?: string;
    dynatrace?: string;
  };
  // impersonation
  impersonationConfig: {
    apiEndpoint: string;
    applicationName: string;
  };
  // static items
  ersContactNumber: string;
  processId: string;
  afiExperienceId: string;
  numberLink: string;
  lifeNumberLink: string;
  lifeBillingLink: string;
  fnolContactNumber: string;
  profileEmailTypeList: Array<string>;
  profileValidateEmailPath: string;
  userIdRetrievalAllowedAttempts: number;
  finAcctConsumerKey?: string;
  modelCoverageDisabledStates: string[];
  optimizelyKey: string;
  datadogApplicationId?: string;
  datadogClientToken?: string;
  datadogServiceName?: string;
  oidc: {
    clientId: string;
    issuer: string;
    redirectUri: string;
    scopes: string[];
    pkce: boolean;
    testing: {
      disableHttpsCheck: boolean;
    };
  };
}

export interface EnvironmentConfigAdminShared {
  production: boolean;
  afiApiKey: string;
  afiAppName: string;
}

export interface EnvironmentConfigFNOL {
  afiApiKey: string;
  applicationTitle: string;
  version: string;
  features: {
    autoFnol: string;
    propertyFnol: string;
  };
  altAuthNApi: string;
  altAuthNApiVersion?: string;
  brandApi: string;
  ebsBrandApi: string;
  brandApiVersion?: string;
  ebsBrandApiVersion?: string;
  claimApi: string;
  claimApiVersion?: string;
  claimFnolApi: string;
  claimFnolApiVersion?: string;
  converseApi: string;
  converseApiVersion?: string;
  creativeVirtualApi: string;
  creativeVirtualApiVersion?: string;
  digitalAccountApi: string;
  digitalAccountApiVersion?: string;
  environment: string;
  partyApi: string;
  partyApiVersion?: string;
  productApi: string;
  productApiVersion?: string;
  reportGlassClaimApi: string;
  reportGlassClaimApiVersion?: string;
  links: {
    amfamAppStoreLink: string;
    amfamGooglePlayLink: string;
    amfamChatUrl: string;
    amfamDotComUrl: string;
    nortonSecurity: string;
    myAccountURL: string;
    fxm: string;
    launch: string;
    amfamGlassKey?: string;
    osiGlassKey?: string;
    midvaleGlassKey?: string;
    reportGlassClaimVendorUrl: string;
    dynatrace?: string;
  };
  // impersonation
  impersonationConfig: {
    apiEndpoint: string;
    applicationName: string;
  };
  gateway?: string;
  processId: string;
  afiExperienceId: string;
  fnolContactNumber: string;
  afiAppName: string;
  afeApiKey: string;
  amfamGlassKey: string;
  osiGlassKey: string;
  midvaleGlassKey: string;
  datadogApplicationId?: string;
  datadogClientToken?: string;
  datadogServiceName?: string;
  optimizelyKey: string;
  featureflagsFile?: string;
}

export interface EnvironmentConfig extends EnvironmentShared {
  leg?: string;
  policyExperienceApi: string;
  environment: string;
  // only in config.json, used for interpolation
  amfamDotCom?: string;
  appDomainTier?: string;
  apps?: string;
  myDotAmfam?: string;
  gateway?: string;
  contentApiGateway?: string;
  sitecoreLambda?: string;
  partnerLandingPageTier?: string;
  finAccount?: string;
  payNow?: string;
  // API endpoints
  addVehicleContextApi: string;
  addVehicleSvc: string;
  plpcContextAPI: string;
  addressLookupApi: string;
  alternateAuthApi: string;
  autoWhatIfApi: string;
  billingApi: string;
  brandApi: string;
  ebsBrandApi: string;
  claimApiv1: string;
  claimEnterpriseApi: string;
  claimEnterpriseApiv2: string;
  reportClaimApi: string;
  claimApi: string;
  claimServicesUtilApi: string;
  claimExposureApi: string;
  communicationApi: string;
  contentApi: string;
  sitecoreApi: string;
  sitecoreLambdaApi: string;
  contextRouterApi: string;
  customerUploadApi: string;
  deleteAccountApi: string;
  digitalAccountApi: string;
  digitalServiceProgramApi: string;
  discountApi: string;
  documentApi: string;
  claimVendorLocations: string;
  eSignatureApi: string;
  financialAccountService: string;
  gatewayTimeApi: string;
  geoApi: string;
  maeApi: string;
  partyApi: string;
  userAccountApi: string;
  paymentApi: string;
  payoroboApi: string;
  pciAuthorizationService: string;
  producerApi: string;
  productApi: string;
  reportGlassClaimApi: string;
  recommenderApi: string;
  ubiApi: string;
  vehicleApi: string;
  claimFnolApi?: string;
  creativeVirtualApi?: string;
  converseApi?: string;
  reliefCreditApi: string;
  recommenderApiV2?: string;

  // links
  links: {
    amfamAppStoreLink: string;
    amfamChatUrl: string;
    amfamDotComUrl: string;
    amfamDotComClaimsFaqUrl: string;
    amfamDRPShopSearchUrl: string;
    amfamGooglePlayLink: string;
    fxm: string;
    htkPortalUrl: string;
    launch: string;
    nortonSecurity: string;
    propertyServiceSsoUrl: string;
    propertyServiceUrl: string;
    reportGlassClaimVendorUrl: string;
    scheduleACallbackUrl: string;
    payNowURL: string;
    reliefPaymentURL: string;
    myAccountURL: string;
    companyInfoPage: string;
    salesForceBeconURL: string;
    dynatrace?: string;
    fileClaimForm?: string; //FNOL app
    claimsPortalUrl?: string; //Admin app
  };
  // impersonation
  impersonationConfig: {
    apiEndpoint: string;
    applicationName: string;
  };
  //forgercok
  forgerock: {
    redirectUri: string;
    scope: string;
    realmPath: string;
    timeout: number;
    webOauthClient: string;
    login: string;
    registration: string;
    changePassword: string;
    afiUrl: string;
    wellsFargoUrl: string;
    uwaaUrl: string;
    direct32Url: string;
    metlifeUrl: string;
    homeGaugeUrl: string;
    insuritasUrl: string;
    electricUrl: string;
    maticUrl: string;
    coverMyStuffUrl: string;
    insurifyUrl: string;
    compareUrl: string;
    connectUrl: string;
    afbaUrl: string;
    onStarInsuranceUrl: string;
    connectNonPartnerUrl: string;
    ameripriseUrl: string;
    costcoChoiceUrl: string;
    costcoEcpUrl: string;
  };
  forgerockEnv?: string;
  // static items
  processId: string;
  afiExperienceId: string;
  numberLink: string;
  lifeNumberLink: string;
  lifeBillingLink: string;
  billingEmail: string;
  fnolContactNumberHref: string;
  fnolContactNumber: string;
  ersContactNumber: string;
  profileEmailTypeList: Array<string>;
  profileValidateEmailPath: string;
  userIdRetrievalAllowedAttempts: number;
  afiAppName: string;
  finAcctConsumerKey?: string;
  amfamGlassKey?: string;
  osiGlassKey?: string;
  midvaleGlassKey?: string;
  modelCoverageDisabledStates: string[];
  optimizelyKey: string;
  gmKey: string;
  afiApiKey: string;
  afeApiKey: string;
  stampsApi: string;
  datadogApplicationId: string;
  datadogClientToken: string;
  datadogServiceName: string;
  featureflagsFile: string;
  //Third Party FNOL APP
  thirdPartyFnolApi?: string;
  thirdPartyFnolConverseApi?: string;
  altAuthNApi?: string;
  //My Account admin
  financialAccountServiceInternal?: string;
  i3Api?: string;
  ssoApi?: string;
  maev3Api?: string;
  maev2Api?: string;
  oidc?: {
    clientId: string;
    issuer: string;
    redirectUri: string;
    scopes: string[];
    pkce: boolean;
    testing: {
      disableHttpsCheck: boolean;
    };
  };
}

//**Partner information plus base shared properties */
export interface EnvironmentShared extends EnvironmentConfigBase {
  partnerName: string;
  partnerId: string;
}

export interface EnvironmentConfigBase extends EnvironmentBase {
  applicationTitle: string;
  version: string;
  featureOverride: { [key: string]: boolean };
  features: {
    addVehicle: string;
    maintenanceRedirect: string;
    chat: string;
    partner: string;
    partnerSso: string;
    fnol: string;
    saveUserID: string;
    typeZeroSecurityQuestions: string;
    opportunities: string;
    photoUpload: string;
    upsellOpportunities: string;
    postFnolFlow: string;
    mobileAppBanner: string;
    accidentChecklist: string;
    tokenBasedEnrollment: string;
    propertyFnol: string;
    reliefCredit: string;
    autoFnol: string;
    reliefCreditPhase2: string;
    classicPastDue: string;
    reliefCreditPhase4: string;
    partnerDynamicFnol: string;
    kydModalCoverage: string;
    paymentAccordionRefactor: string;
    autoPayRefactor: string;
    autoPayPhaseTwo: string;
    reliefCreditPhase5: string;
    ie11Disclaimer: string;
    replaceVehicleQuickQuote: string;
    cookieCheck: string;
    opportunitiesV2: string;
    partnerAddVehicle: string;

    // environment values
    production?: boolean;
    devMode?: boolean;
    suppressErrorPage?: boolean;
    billingCareCentreEmail?: string;
    billingPersonalLinesEmail?: string;
    billingCommercialLinesEmail?: string;
    billingInternalFromEmail?: string;
    policyChangeRequestInternal?: string;
    policyGracePeriodNotificatonInternal?: string;
    policyGracePeriodNotificatonInternalAgencyMailbox?: string;
    claimContantAdjusterInternal?: string;
    claimReportClaimInternal?: string;
    partnerBillingEmail?: string;
    partnerClaimEmail?: string;
    partnerAdjusterEmail?: string;
    gaProperty?: string;
    afiApiKey?: string;
    afeApiKey?: string;
  };

  // API endpoint versions
  // addVehicleContextApiVersion?: string;
  // addressLookupApiVersion?: string;
  // alternateAuthApiVersion?: string;
  // autoWhatIfApiVersion?: string;
  // billingApiVersion?: string;
  // brandApiVersion?: string;
  // ebsBrandApiVersion?: string;
  // claimApiv1Version?: string;
  // claimEnterpriseApiVersion?: string;
  // claimEnterpriseApiPropertyVersion?: string;
  // claimEnterpriseGateway?: string;
  // reportClaimApiVersion?: string;
  // claimApiVersion?: string;
  // claimServicesUtilApiVersion?: string;
  // claimExposureApiVersion?: string;
  // communicationApiVersion?: string;
  // contentApiVersion?: string;
  // customerUploadApiVersion?: string;
  // deleteAccountApiVersion?: string;
  // digitalAccountApiVersion?: string;
  // digitalServiceProgramApiVersion?: string;
  // discountApiVersion?: string;
  // documentApiVersion?: string;
  // claimVendorLocationsVersion?: string;
  // eSignatureApiVersion?: string;
  // finAccountVersion?: string;
  // gatewayTimeApiVersion?: string;
  // geoApiVersion?: string;
  // i3ApiVersion?: string;
  // maeApiVersion?: string;
  // partyApiVersion?: string;
  // paymentApiVersion?: string;
  // pciAuthorizationApiVersion?: string;
  // producerApiVersion?: string;
  // productApiVersion?: string;
  // reportGlassClaimApiVersion?: string;
  // ssoApiVersion?: string;
  // ubiApiVersion?: string;
  // vehicleApiVersion?: string;
  // claimFnolApiVersion?: string;
  // creativeVirtualApiVersion?: string;
  // converseApiVersion?: string;
  // reliefCreditApi: string;
  // reliefCreditApiVersion?: string;
  // links
}

//** My accounts original shared properties */
export interface EnvironmentBase {
  production: boolean;
  devMode: boolean;
  suppressErrorPage: boolean;
  billingCareCentreEmail: string;
  billingPersonalLinesEmail: string;
  billingCommercialLinesEmail: string;
  billingInternalFromEmail: string;
  policyChangeRequestInternal: string;
  policyGracePeriodNotificatonInternal: string;
  policyGracePeriodNotificatonInternalAgencyMailbox: string;
  claimContantAdjusterInternal: string;
  claimReportClaimInternal: string;
  partnerBillingEmail: string;
  partnerClaimEmail: string;
  partnerAdjusterEmail: string;
  partnerLicensedAdvisorEmail: string;
  gaProperty: string;
  currentDate: Date;
}
